var _defs, _path, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMadring(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1920 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: none;\n        stroke: #fff;\n        stroke-miterlimit: 10;\n        stroke-width: 15.1px;\n      }\n\n      .st1 {\n        opacity: .6;\n      }\n\n      .st1, .st2, .st3, .st4, .st5 {\n        fill: #fff;\n      }\n\n      .st2 {\n        opacity: .9;\n      }\n\n      .st3 {\n        opacity: .8;\n      }\n\n      .st4 {\n        opacity: .7;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M469.7,887.3l-60.3-368.3s3-16.4-19.5-15.8c-22.5.6-20.1,0-23.7-15.8s-4.3-25.6-4.3-25.6c0,0-2.4-49.3,32.3-71.8,34.7-22.5,205.1-129.1,205.1-129.1,0,0,85.2-57.8,179-67,11,0,81.6-4.9,130.9,31,9.1,6.1,17.7,14,21.9,2.4,4.3-11.6,9.7-9.7,16.4-5.5s11,9.1,28.6,5.5,57.8-17.7,66.4-26.8c8.5-9.1,26.2-15.8,31-16.4s56.6-7.3,70.6-18.9c9.1-8.5,16.4-14.6,23.7,0,7.9,8.5,21.3,29.2,46.9,15.8,25.6-13.4,31-17.7,31-17.7,0,0,7.3-7.9,42.6-7,35.3.9,53,0,53,0,0,0,26.2-3.3,43.2,21.7,13.4,17.7,20.7,26.2,20.7,26.2,0,0,12.2,15.2,34.1,13.4s48.1-17,48.1-17c0,0,52.4-27.4,86.4-7.3,12.2,11,39.6,33.5,28,88.3-11,24.3-35.9,79.1-130.3,43.2-7.3-4.3-48.7-27.4-83.4-55.4-34.7-28-59.7-53.6-77.3-62.1-17.7-8.5-23.7-21.3-48.7,7.9l-37.1,51.1s-17.7,29.2-48.1,30.4c-30.4,1.2-63.3,0-63.3,0,0,0-48.7,1.2-77.9,40.8-3.7,9.1-12.2,17.7-13.4,52.4-1.2,34.7-.6,55.4-.6,55.4,0,0-.6,13.4,7.9,29.2l8.5,15.8s10.3,9.1-4.9,18.3c-15.2,9.1-104.1,62.7-104.1,62.7,0,0-24.3,12.2-25,36.5s3.7,45.7,3.7,45.7c0,0,14,65.1-26.2,82.2-40.2,17-161.3,29.2-161.3,29.2l-38.4,6.7s-27.4,6.1-14.6,20.7c12.8,14.6,12.2,18.9,13.4,31,1.2,12.2,2.4,17.7,3,25,.6,7.3,1.8,26.2,1.8,26.2,0,0,5.5,6.7-15.8,12.8s-122.4,34.7-176.5,34.7-17.1,5.9-23.7-34.7Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M438,488.3h-4.8v-5.2h15.7v5.2h-5.2v14.7h-5.7v-14.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M459.9,483.2v19.8h-5.6v-14.4l-3.2,1-1.3-4.7,5.6-1.7h4.5Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M331.7,524.7h-4.8v-5.2h15.7v5.2h-5.2v14.7h-5.7v-14.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M359,534.5v4.8h-14.8v-2c0-3.1,2.1-5.6,5.4-7.7,2.9-1.9,3.5-2.3,3.5-3.4s-.6-1.7-1.7-1.7-1.7.7-1.7,2.3h-5.6c0-4.7,2.8-7.5,7.6-7.5s7.1,2.4,7.1,6.4-1.8,4.8-5.2,7c-1.3.8-2.3,1.4-3,2.1h8.3Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M316.9,392.7h-4.8v-5.2h15.7v5.2h-5.2v14.7h-5.7v-14.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M344.3,401.9c0,3.5-3.1,5.9-7.5,5.9s-7.3-2.6-7.5-7.1h5.3c0,1.3.8,2.1,2,2.1s2-.7,2-1.8-.7-1.7-2-1.7h-1.9v-4h1.8c1.3,0,2-.6,2-1.6s-.7-1.6-1.9-1.6-2,.8-2,2h-5.2c.2-4.2,3.1-6.8,7.6-6.8s7,2.3,7,5.7-.9,3.5-2.6,4.4c1.9.9,3,2.5,3,4.6Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M757.2,150.8h-4.8v-5.2h15.7v5.2h-5.2v14.7h-5.7v-14.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M784.3,162.4h-2.2v3h-5.6v-3h-8.8v-4.3l8.3-12.5h6.1v12.2h2.2v4.6ZM773.1,157.8h3.9v-6.2l-3.9,6.2Z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M900.7,268.7h-4.8v-5.2h15.7v5.2h-5.2v14.7h-5.7v-14.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M928.9,276.8c0,4.2-3,6.9-7.7,6.9s-7.2-2.5-7.4-6.8h5.4c.1,1.1.9,1.8,2,1.8s2.1-.9,2.1-2.3-.9-2.2-2.1-2.2-1.4.4-1.8,1h-5.1v-11.8h13.6v4.8h-8.3v2.5c.9-.4,1.9-.7,3-.7,3.7,0,6.4,2.8,6.4,6.6Z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M952.9,175.4h-4.8v-5.2h15.7v5.2h-5.2v14.7h-5.7v-14.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M973.4,176.2c3.3.5,5.7,3.3,5.7,6.8s-3.4,7.4-7.7,7.4-7.6-3.3-7.6-7.6.5-3.2,2.4-5.9l4.5-6.7h6.6l-3.9,6ZM973.7,183c0-1.3-1-2.3-2.3-2.3s-2.2,1-2.2,2.3.9,2.3,2.2,2.3,2.3-1,2.3-2.3Z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1053.2,224.5h-4.8v-5.2h15.7v5.2h-5.2v14.7h-5.7v-14.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1079.8,219.4v4.7l-7.2,15.1h-6.1l7.4-14.8h-8.3v-5h14.2Z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1123,118.7h-4.8v-5.2h15.7v5.2h-5.2v14.7h-5.7v-14.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1151.1,127.8c0,3.6-2.9,6-7.7,6s-7.7-2.3-7.7-6,1-3.8,2.8-4.8c-1.6-.9-2.4-2.4-2.4-4.2,0-3.4,2.9-5.6,7.4-5.6s7.4,2.2,7.4,5.6-.9,3.3-2.4,4.2c1.8,1,2.8,2.6,2.8,4.8ZM1145.5,127.5c0-1.2-.9-2.1-2.1-2.1s-2.2.9-2.2,2.2.9,2,2.2,2,2.2-.8,2.2-2ZM1141.4,119.2c0,1.1.8,1.9,1.9,1.9s1.9-.8,1.9-1.9-.8-1.8-1.9-1.8-2,.8-2,1.8Z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1184.7,216.1h-4.8v-5.2h15.7v5.2h-5.2v14.7h-5.7v-14.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1202.7,224.9c-3.3-.5-5.7-3.3-5.7-6.8s3.4-7.4,7.7-7.4,7.6,3.3,7.6,7.6-.5,3.2-2.4,5.9l-4.5,6.7h-6.6l3.9-6ZM1202.4,218c0,1.3,1,2.3,2.3,2.3s2.2-1,2.2-2.3-.9-2.3-2.2-2.3-2.3,1-2.3,2.3Z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1392.5,131.6h-4.8v-5.2h15.7v5.2h-5.2v14.7h-5.7v-14.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1414.4,126.5v19.8h-5.6v-14.4l-3.2,1-1.3-4.7,5.6-1.7h4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1417.4,136.4c0-6,4.4-10.3,10.6-10.3s10.6,4.3,10.6,10.3-4.4,10.3-10.6,10.3-10.6-4.3-10.6-10.3ZM1432.8,136.4c0-2.9-2.1-5.1-4.8-5.1s-4.9,2.2-4.9,5.1,2.1,5.2,4.9,5.2,4.8-2.2,4.8-5.2Z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1445.4,245.1h-4.8v-5.2h15.7v5.2h-5.2v14.7h-5.7v-14.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1467.4,239.9v19.8h-5.6v-14.4l-3.2,1-1.3-4.7,5.6-1.7h4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1479.5,239.9v19.8h-5.6v-14.4l-3.2,1-1.3-4.7,5.6-1.7h4.5Z"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1540.7,254.6h-4.8v-5.2h15.7v5.2h-5.2v14.7h-5.7v-14.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1562.6,249.4v19.8h-5.6v-14.4l-3.2,1-1.3-4.7,5.6-1.7h4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1580.5,264.5v4.8h-14.8v-2c0-3.1,2.1-5.6,5.4-7.7,2.9-1.9,3.5-2.3,3.5-3.4s-.6-1.7-1.7-1.7-1.7.7-1.7,2.3h-5.6c0-4.7,2.8-7.5,7.6-7.5s7.1,2.4,7.1,6.4-1.8,4.8-5.2,7c-1.3.8-2.3,1.4-3,2.1h8.3Z"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1278.8,242.3h-4.8v-5.2h15.7v5.2h-5.2v14.7h-5.7v-14.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1300.7,237.1v19.8h-5.6v-14.4l-3.2,1-1.3-4.7,5.6-1.7h4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1318.6,251.4c0,3.5-3.1,5.9-7.5,5.9s-7.3-2.6-7.5-7.1h5.3c0,1.3.8,2.1,2,2.1s2-.7,2-1.8-.7-1.7-2-1.7h-1.9v-4h1.8c1.3,0,2-.6,2-1.6s-.7-1.6-1.9-1.6-2,.8-2,2h-5.2c.2-4.2,3.1-6.8,7.6-6.8s7,2.3,7,5.7-.9,3.5-2.6,4.4c1.9.9,3,2.5,3,4.6Z"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1196.3,321.1h-4.8v-5.2h15.7v5.2h-5.2v14.7h-5.7v-14.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1218.2,316v19.8h-5.6v-14.4l-3.2,1-1.3-4.7,5.6-1.7h4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1237.6,332.8h-2.2v3h-5.6v-3h-8.8v-4.3l8.3-12.5h6.1v12.2h2.2v4.6ZM1226.5,328.2h3.9v-6.2l-3.9,6.2Z"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M994.9,297.6h-4.8v-5.2h15.7v5.2h-5.2v14.7h-5.7v-14.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1016.8,292.5v19.8h-5.6v-14.4l-3.2,1-1.3-4.7,5.6-1.7h4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1035.5,305.8c0,4.2-3,6.9-7.7,6.9s-7.2-2.5-7.4-6.8h5.4c.1,1.1.9,1.8,2,1.8s2.1-.9,2.1-2.3-.9-2.2-2.1-2.2-1.4.4-1.8,1h-5.1v-11.8h13.6v4.8h-8.3v2.5c.9-.4,1.9-.7,3-.7,3.7,0,6.4,2.8,6.4,6.6Z"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M958.9,462.4h-4.8v-5.2h15.7v5.2h-5.2v14.7h-5.7v-14.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M980.8,457.2v19.8h-5.6v-14.4l-3.2,1-1.3-4.7,5.6-1.7h4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M993.2,463.2c3.3.5,5.7,3.3,5.7,6.8s-3.4,7.4-7.7,7.4-7.6-3.3-7.6-7.6.5-3.2,2.4-5.9l4.5-6.7h6.6l-3.9,6ZM993.5,470c0-1.3-1-2.3-2.3-2.3s-2.2,1-2.2,2.3.9,2.3,2.2,2.3,2.3-1,2.3-2.3Z"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1075.3,501.4h-4.8v-5.2h15.7v5.2h-5.2v14.7h-5.7v-14.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1097.3,496.3v19.8h-5.6v-14.4l-3.2,1-1.3-4.7,5.6-1.7h4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1114.4,496.3v4.7l-7.2,15.1h-6.1l7.4-14.8h-8.3v-5h14.2Z"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M843.3,575.6h-4.8v-5.2h15.7v5.2h-5.2v14.7h-5.7v-14.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M865.2,570.5v19.8h-5.6v-14.4l-3.2,1-1.3-4.7,5.6-1.7h4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M883.9,584.7c0,3.6-2.9,6-7.7,6s-7.7-2.3-7.7-6,1-3.8,2.8-4.8c-1.6-.9-2.4-2.4-2.4-4.2,0-3.4,2.9-5.6,7.4-5.6s7.4,2.2,7.4,5.6-.9,3.3-2.4,4.2c1.8,1,2.8,2.6,2.8,4.8ZM878.3,584.5c0-1.2-.9-2.1-2.1-2.1s-2.2.9-2.2,2.2.9,2,2.2,2,2.2-.8,2.2-2ZM874.2,576.1c0,1.1.8,1.9,1.9,1.9s1.9-.8,1.9-1.9-.8-1.8-1.9-1.8-2,.8-2,1.8Z"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M926.1,736.1h-4.8v-5.2h15.7v5.2h-5.2v14.7h-5.7v-14.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M948,731v19.8h-5.6v-14.4l-3.2,1-1.3-4.7,5.6-1.7h4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M956.5,744.9c-3.3-.5-5.7-3.3-5.7-6.8s3.4-7.4,7.7-7.4,7.6,3.3,7.6,7.6-.5,3.2-2.4,5.9l-4.5,6.7h-6.6l3.9-6ZM956.2,738c0,1.3,1,2.3,2.3,2.3s2.2-1,2.2-2.3-.9-2.3-2.2-2.3-2.3,1-2.3,2.3Z"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M591.3,765.7h-4.8v-5.2h15.7v5.2h-5.2v14.7h-5.7v-14.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M618.6,775.6v4.8h-14.8v-2c0-3.1,2.1-5.6,5.4-7.7,2.9-1.9,3.5-2.3,3.5-3.4s-.6-1.7-1.7-1.7-1.7.7-1.7,2.3h-5.6c0-4.7,2.8-7.5,7.6-7.5s7.1,2.4,7.1,6.4-1.8,4.8-5.2,7c-1.3.8-2.3,1.4-3,2.1h8.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M620.3,770.4c0-6,4.4-10.3,10.6-10.3s10.6,4.3,10.6,10.3-4.4,10.3-10.6,10.3-10.6-4.3-10.6-10.3ZM635.8,770.4c0-2.9-2.1-5.1-4.8-5.1s-4.9,2.2-4.9,5.1,2.1,5.2,4.9,5.2,4.8-2.2,4.8-5.2Z"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M718.2,892.5h-4.8v-5.2h15.7v5.2h-5.2v14.7h-5.7v-14.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M745.5,902.4v4.8h-14.8v-2c0-3.1,2.1-5.6,5.4-7.7,2.9-1.9,3.5-2.3,3.5-3.4s-.6-1.7-1.7-1.7-1.7.7-1.7,2.3h-5.6c0-4.7,2.8-7.5,7.6-7.5s7.1,2.4,7.1,6.4-1.8,4.8-5.2,7c-1.3.8-2.3,1.4-3,2.1h8.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M756.8,887.4v19.8h-5.6v-14.4l-3.2,1-1.3-4.7,5.6-1.7h4.5Z"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M455.9,952.6h-4.8v-5.2h15.7v5.2h-5.2v14.7h-5.7v-14.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M483.2,962.4v4.8h-14.8v-2c0-3.1,2.1-5.6,5.4-7.7,2.9-1.9,3.5-2.3,3.5-3.4s-.6-1.7-1.7-1.7-1.7.7-1.7,2.3h-5.6c0-4.7,2.8-7.5,7.6-7.5s7.1,2.4,7.1,6.4-1.8,4.8-5.2,7c-1.3.8-2.3,1.4-3,2.1h8.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M499.8,962.4v4.8h-14.8v-2c0-3.1,2.1-5.6,5.4-7.7,2.9-1.9,3.5-2.3,3.5-3.4s-.6-1.7-1.7-1.7-1.7.7-1.7,2.3h-5.6c0-4.7,2.8-7.5,7.6-7.5s7.1,2.4,7.1,6.4-1.8,4.8-5.2,7c-1.3.8-2.3,1.4-3,2.1h8.3Z"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "455.8 579.5 448 590.4 449.1 597 456.9 586.1 467.8 593.9 466.7 587.2 455.8 579.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "453.7 568.3 446 579.2 447.1 585.9 454.9 575 465.8 582.7 464.7 576.1 453.7 568.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "451.9 557 444.1 567.9 445.3 574.6 453 563.6 464 571.4 462.8 564.8 451.9 557"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "449.8 600.8 450.9 607.5 458.7 596.6 469.6 604.3 468.5 597.7 457.5 589.9 449.8 600.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "451.6 611.3 452.7 617.9 460.5 607 471.4 614.8 470.3 608.2 459.3 600.4 451.6 611.3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M489.9,637.7l-6.6,1.1-1.1-6.6,6.6-1.1,1.1,6.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M488.8,631.1l-6.6,1.1-1.1-6.6,6.6-1.1,1.1,6.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.7,624.5l-6.6,1.1-1.1-6.6,6.6-1.1,1.1,6.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M483.4,638.8l-6.6,1.1-1.1-6.6,6.6-1.1,1.1,6.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M481.2,625.5l-6.6,1.1-1.1-6.6,6.6-1.1,1.1,6.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.3,632.2l-6.6,1.1-1.1-6.6,6.6-1.1,1.1,6.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.8,639.9l-6.6,1.1-1.1-6.6,6.6-1.1,1.1,6.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M475.7,633.3l-6.6,1.1-1.1-6.6,6.6-1.1,1.1,6.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.6,626.7l-6.6,1.1-1.1-6.6,6.6-1.1,1.1,6.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M470.3,641l-6.6,1.1-1.1-6.6,6.6-1.1,1.1,6.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M468,627.8l-6.6,1.1-1.1-6.6,6.6-1.1,1.1,6.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.2,634.4l-6.6,1.1-1.1-6.6,6.6-1.1,1.1,6.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.9,642.3l-6.6,1.1-1.1-6.6,6.6-1.1,1.1,6.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M462.7,635.7l-6.6,1.1-1.1-6.6,6.6-1.1,1.1,6.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.6,629.1l-6.6,1.1-1.1-6.6,6.6-1.1,1.1,6.6Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMadring);
export default __webpack_public_path__ + "static/media/madring.912f1c79ffcf674d0a1abd1317bdb372.svg";
export { ForwardRef as ReactComponent };